import React from "react";
import { Typography, Card, Grid2 } from "@mui/material";
import withToast from "../../hocs/withToast";
import withNavigate from "../../hocs/withNavigate";

/**
 * GenericMetricsCards Component
 * 
 * This component displays a set of metric cards with dynamic data.
 * Each card represents a specific metric with a label, count, and background color.
 * Clicking a card navigates to the "Patient Population Table" page.
 * 
 * @param {Array} metrics - Array of metric objects with properties:
 *   @property {string} label - The name of the metric.
 *   @property {number} count - The numeric value of the metric.
 *   @property {string} bgColor - The background color for the card.
 *   @property {string} color - The text color for the card.
 */
const GenericMetricsCards = ({ metrics, notify, navigate }) => {

  /**
   * Handles card click event
   * Navigates the user to the "Patient Population Table" page.
   */
  const handleCardClick = (cardMetric, cardMeta, vitalName, vitalCount) => {
    if (!parseInt(vitalCount))
      return notify('No Patient for that vital mertic', 'error')

    navigate("/patient-population-table", {
      state: { cardMetric, cardMeta, vitalName },
    });
  };

  return (
    <Grid2
      container
      sx={{
        bgcolor: "white",
        py: 1,
        px: 4,
        justifyContent: { xs: "center", sm: "center", md: "flex-start" }, // Responsive alignment
      }}
    >
      {metrics.metrics.map((metric) => (
        <Grid2
          item
          xs={12}
          sm={6}
          md={3}
          key={metric.label}
          sx={{ p: 0.5 }}
        >
          <Card
            role="presentation"
            onClick={() => handleCardClick(metric.code, metrics.code, metrics.name, metric.count)}
            sx={{
              p: 2,
              textAlign: "center",
              boxShadow: 2,
              height: 100,
              width: 150,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: 1,
              bgcolor: metric.bgColor,
              color: metric.color,
              cursor: "pointer",
              transition: "0.3s",
              "&:hover": { boxShadow: 4 },
            }}
          >
            <Typography variant="subtitle2" fontWeight="bold">
              {metric.label}
            </Typography>
            <Typography variant="h4" fontWeight="bold">
              {metric.count}
            </Typography>
          </Card>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default withToast(withNavigate(GenericMetricsCards));
